import React from 'react';
import visa from './ico/visa.png';
import mastercard from './ico/mastercard.png';
const CreditCard = ({onChange, checked}) => (
    <div className="btn-radio-cantainer form-group row btn-radio-cantainer">
         <div className="label-radio col-sm-4"></div> 
    <div className="form-check col-sm-8">
        <div className="block-radio-btn">
                <label className="label-radio">
                    <input type="radio" name= "type" className="btn-radio" value="MASTERCARD" onChange={onChange} checked={checked==="MASTERCARD"} /> {' '}
                    < img src={mastercard} className="ico-typeCard" />     
                </label>
            </div>
            <div className="block-radio-btn">
                <label className="label-radio">
                    <input type="radio" name= "type" className="btn-radio" value="VISA" onChange={onChange} checked={checked==="VISA"} /> {' '}
                    < img src={visa} className="ico-typeCard" />     
                </label>
            </div>
    </div>
</div> 
);
export default CreditCard;



// WEBPACK FOOTER //
// ./src/components/creditCard/CreditCard.js